import React, { Component } from 'react'

import Settings from '../../components/Settings'
import History from '../../components/History'


import './CabinetPage.scss'

export default class CabinetPage extends Component {
  state = { 
    activeTab: 0,
  }

  chgActiveTab = id => {
    this.setState({activeTab: id})
  }

  render() {
    return (<div className="row">
      <div className="col-12">
        <div>
          <ul className="cabinet-menu">
            <li className={this.state.activeTab === 0 ? 'active' : null } onClick={() => this.chgActiveTab(0)}>
              <i class="navbar-item__icon icons setting-icon"></i>
              Мои настройки
            </li>
            <li className={this.state.activeTab === 1 ? 'active' : null } onClick={() => this.chgActiveTab(1)}>
              <i class="navbar-item__icon icons history-icon"></i>
              История поездок
            </li>
          </ul>
        </div>
      </div>
      <div className="col-12">
        {this.state.activeTab === 0 ? <Settings /> : null }
        {this.state.activeTab === 1 ? <History /> : null }
      </div>  
    </div>)
  }
}
